import { Redirect, useParams } from "wouter";

export function OrgRootRedirect() {
  const { orgSlug } = useParams<{ orgSlug: string }>();
  return <Redirect to={`/o/${orgSlug}/overview`} />;
}
